import './index.css';
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import TimeContext from './context/TimeContext';
import SymbolContext from './context/SymbolContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <TimeContext>
            <SymbolContext>
                <App />
            </SymbolContext>
        </TimeContext>
    </>
);


